'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import Image from 'next/image'

export default function LoginPage() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const router = useRouter()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (password === 'ToolouerZxsWd54') {
      document.cookie = `toolouer_auth=${password}; path=/; max-age=${60 * 60 * 24 * 30}` // 30 jours
      router.push('/')
      router.refresh()
    } else {
      setError('Mot de passe incorrect')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-secondary p-8 rounded-lg shadow-md w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Image
            src="/e59ec9a9_logo2.18b3d9b3.svg"
            alt="Toolouer"
            width={200}
            height={56}
            className="h-14 w-auto"
          />
        </div>

        <p className="text-white/80 text-center mb-6">
          Un mot de passe est requis pour accéder à la préprod.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-white border-2 border-white/20 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-gray-800 placeholder:text-gray-400"
              placeholder="Mot de passe"
              autoFocus
            />
          </div>

          {error && (
            <p className="text-red-300 text-sm">{error}</p>
          )}

          <button
            type="submit"
            className="w-full bg-primary text-primary-foreground font-medium py-2 px-4 rounded-md hover:bg-primary/90 transition-colors"
          >
            Accéder au site
          </button>
        </form>
      </div>
    </div>
  )
}
